import template from './reportImages.html';
import controller from './reportImages.controller';
import './reportImages.scss';

let reportImagesComponent = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  },
  template,
  controller,
  controllerAs: "vm"
};

export default reportImagesComponent;



// WEBPACK FOOTER //
// ./client/app/common/reportImages/reportImages.component.js